import { Link } from "react-router-dom";
import { usePageMeta } from "@/components/site/Seo";

export default function NotFound() {
  usePageMeta("Page not found", "This page could not be found.");
  return (
    <section className="wrap py-32 text-cream" data-testid="not-found-page">
      <p className="eyebrow-dark">404</p>
      <h1 className="mt-6 text-6xl sm:text-8xl">This path <em className="text-gold-soft">isn't planted yet.</em></h1>
      <Link to="/" className="btn-gold mt-10" data-testid="not-found-home-link">Back to home</Link>
    </section>
  );
}
